import { action } from "@ember/object";
import { service } from "@ember/service";
import dayjs from "dayjs";
import type { ForcBaseArgs } from "parog-web/components/forc/abstract/base-component";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import type Patient from "parog-web/models/patient";
import type TaskPlannedJournalEvent from "parog-web/models/task-planned-journal-event";
import type FetcherService from "parog-web/services/fetcher";
import formatToISO8601Date from "parog-web/utils/format-to-iso8601-date";

interface Signature {
  Args: {
    patient: Patient;
  } & ForcBaseArgs;
}

export default abstract class MiciBaseEditionFormEditionForm extends CrudJournalEventBaseComponent<Signature> {
  @service declare fetcher: FetcherService;

  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  get currentSections(): Array<string> {
    return [];
  }

  @action
  async save(): Promise<typeof this.journalEventClass> {
    let task: TaskPlannedJournalEvent | null = null;

    if (
      Boolean(this.args.originJournalEventType) &&
      this.args.originJournalEventType == "TaskPlannedJournalEvent" &&
      Boolean(this.args.originJournalEventId)
    ) {
      task = this.store.peekRecord(
        "task-planned-journal-event",
        Number(this.args.originJournalEventId)
      );
      if (task) {
        this.changeset.set("originTaskIdentifier", task.originTaskIdentifier);
      }
    }

    await super.save();

    if (task) {
      await task.processTask("treated", true);
    }

    await this.fetcher.loadRecords("task-processed-journal-event", {
      filter: {
        patient_id: this.args.patient.id,
        occurred_at_gte: formatToISO8601Date(dayjs().startOf("day").toDate())
      }
    });

    if (this.afterCompleted) {
      await this.afterCompleted();
    }
  }
}
